module.exports = __webpack_public_path__ + "static/media/plus.ee99264c.svg";